'use strict';
import swiperHelper from './product/swiperHelper';

var noSlides = 4.80; // default value for slides per view, will be updated based on layout adjustments

/**
 * Validates and Return the cquotient namespace provided by the commerce cloud platform
 * @returns {Object} - einsteinUtils or null
 */
export function getEinsteinUtils() {
    var einsteinUtils = window.CQuotient;
    if (einsteinUtils && (typeof einsteinUtils.getCQUserId === 'function') && (typeof einsteinUtils.getCQCookieId === 'function')) {
        return einsteinUtils;
    }
    return null;
}

/**
 * Renders the einstein response into a given dom element
 */
export function showControls() {
    var $carousel = $('.experience-einReco-wrapper .einsteinReco-wrapper__slot-caro');
    swiperHelper.createSwiperCarousel($carousel, {
        slidesPerView: 3.6,
        freeMode: true,
        pagination: false,
        mousewheel: true,
        keyboard: { enabled: true },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize: '140px'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            768: {
                slidesPerView: noSlides
            }
        },
        on: {
            afterInit: function (swiper) {
                var swiperEl = swiper.el;
                var wrapperEl = swiper.wrapperEl;
                $(swiperEl).on('focusin', '.swiper-slide', function () {
                    var slide = this;
                    var slideLeft = slide.offsetLeft;
                    var slideWidth = slide.offsetWidth;
                    var currentOffset = Math.abs(swiper.translate);
                    var viewWidth = $(swiperEl).width();

                    if (slideLeft < currentOffset || (slideLeft + slideWidth) > (currentOffset + viewWidth)) {
                        var newTranslate = -(slideLeft);
                        var max = swiper.maxTranslate();
                        if (newTranslate < max) newTranslate = max;
                        swiper.setTranslate(newTranslate);
                    }

                    if (swiperEl) swiperEl.scrollLeft = 0;
                    if (wrapperEl) wrapperEl.scrollLeft = 0;
                    setTimeout(function () {
                        if (swiperEl) swiperEl.scrollLeft = 0;
                        if (wrapperEl) wrapperEl.scrollLeft = 0;
                    }, 0);
                });
            }
        }
    });
}

/**
 * fills in the carousel with product tile html objects
 * @param {string} einsteinResponse string html for product tiles
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @param {Object} einsteinUtils cquotient object
 */
export function fillDomElement(einsteinResponse, $parentElement, einsteinUtils) {
    var recommender = $parentElement.data('recommender');
    var recommendedProducts = einsteinResponse[recommender].recs;
    var einsteinResponseRecoUUID = einsteinResponse[recommender].recoUUID;
    var pinnedProductArrayData = $parentElement.data('productarray') ? $parentElement.data('productarray') : null;

    if ((recommendedProducts && recommendedProducts.length > 0) || pinnedProductArrayData) {
        var template = $parentElement.data('template');
        var inventoryThreshold = $parentElement.data('inventorythreshold');
       // var swatches = $parentElement.data('swatches');
        var showQuickView = $parentElement.data('showquickview');

        recommendedProducts = recommendedProducts || [];
        var components = [];
        var seenIds = new Set(); // Track seen product IDs to avoid duplicates
        var einsteinResponseProductIds = [];

        recommendedProducts.forEach(function (recommendedProduct) {
            if (recommendedProduct && recommendedProduct.id) {
                einsteinResponseProductIds.push({ id: recommendedProduct.id });
            }
        });

        // Convert comma-separated string to array
        var pinnedProductArray = [];
        if (pinnedProductArrayData && typeof pinnedProductArrayData === 'string') {
            pinnedProductArray = pinnedProductArrayData.split(',').map(function (id) {
                return id.trim(); // Remove whitespace
            }).filter(function (id) {
                return id; // Remove empty strings
            });
        } else if (pinnedProductArrayData && Array.isArray(pinnedProductArrayData)) {
            pinnedProductArray = pinnedProductArrayData;
        }

        /**
         * Function to create tile definition
         * @param {string} productId product id for tile
         * @param {string} template  the name of the isml template to render
         * @param {boolean} showQuickView passing boolean value
         * @returns {Object} returning new tile for quickview modal
        */
        var createTileDefinition = function (productId) {
            return {
                template: template,
                showQuickView: showQuickView,
                model: {
                    type: 'product',
                    id: productId
                }
            };
        };

        // Step 1: Add pinned products first (with null check)
        if (pinnedProductArray && pinnedProductArray.length > 0) {
            pinnedProductArray.forEach(function (productId) {
                if (productId && !seenIds.has(productId)) {
                    components.push(createTileDefinition(productId));
                    seenIds.add(productId);
                }
            });
        }

        // Step 2: Add recommended products (skip duplicates, with null check)
        if (recommendedProducts && recommendedProducts.length > 0) {
            var recommendedComponents = recommendedProducts
                .filter(function (recommendedProduct) {
                    return recommendedProduct && recommendedProduct.id && !seenIds.has(recommendedProduct.id);
                })
                .map(function (recommendedProduct) {
                    seenIds.add(recommendedProduct.id);
                    return createTileDefinition(recommendedProduct.id);
                });

            components = components.concat(recommendedComponents);
        }

        // Step 3: Ensure components is never null
        components = components && components.length > 0 ? components : [];

        var url = new URL($parentElement.data('product-load-url'));
        url.searchParams.append('components', JSON.stringify(components));
        url.searchParams.append('limit', $parentElement.data('limit'));
        url.searchParams.append('inventorythreshold', inventoryThreshold);
        url.searchParams.append('recommender', recommender);
       // url.searchParams.append('productArray', $parentElement.data('productArray'));
        $.ajax({
            url: url.href,
            type: 'get',
            dataType: 'html',
            success: function (data) {
                const $html = $('<div>').html(data);

                // Update attribute on matched elements
                $html.find('.plp-img-container')
                    .attr('data-product-image-attr', ' ');

                $html.find('.quickview__button')
                    .attr('tabindex', ' ');

                // ADA: only product name link is the tab stop
                $html.find('.product-tile').attr('tabindex', '-1');
                $html.find('.pdpurl').attr('tabindex', '-1').attr('aria-hidden', 'true');
                $html.find('.ds-product-name').attr('tabindex', '0');
                // Inject the updated HTML
                $parentElement.find('.swiper-wrapper').html($html.html());

                const $count = $html.find('.einsteinReco-wrapper__tile').length;
                if ($count === 0 || ($count < $parentElement.data('minlimit'))) {
                    if ($parentElement.closest('.experience-einstein-pvhEinsteinCarouselCategory').length) {
                        $parentElement.closest('.experience-einstein-pvhEinsteinCarouselCategory').closest('.region').hide();
                        return;
                    }

                    if ($parentElement.closest('.experience-einstein-pvhEinsteinCarousel').length) {
                        $parentElement.closest('.experience-einstein-pvhEinsteinCarousel').closest('.region').hide();
                        return;
                    }
                }

                if ($(window).width() <= 767) {
                    if ($count < 3.5) {
                        $parentElement.find('.swiper-button-controls-wrapper').hide();
                    }
                } else if ($(window).width() > 767) {
                    if ($count < noSlides) {
                        $parentElement.find('.swiper-button-controls-wrapper').hide();
                    }
                }

                einsteinUtils.sendActivity(einsteinUtils.clientId, 'viewReco', {
                    recommenderName: recommender,
                    __recoUUID: einsteinResponseRecoUUID,  // from the API response
                    products: einsteinResponseProductIds, // list of product IDs being rendered
                    userId: einsteinUtils.getCQUserId(),
                    cookieId: einsteinUtils.getCQCookieId(),
                    ccver: '1.01'
                });

                showControls($parentElement);
                PVH.mountAllComponents('quickView');
            },
            error: function () {
                $parentElement.spinner().stop();
                $parentElement.closest('.experience-einstein-pvhEinsteinCarouselCategory').closest('.region').hide();
                $parentElement.closest('.experience-einstein-pvhEinsteinCarousel').closest('.region').hide();
            }
        });
    } else {
        $parentElement.closest('.experience-einstein-pvhEinsteinCarouselCategory').closest('.region').hide();
        $parentElement.closest('.experience-einstein-pvhEinsteinCarousel').closest('.region').hide();
    }
}

 /**
 * Processes a recommendation tile, with an already initialized category specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @param {Object} einsteinUtils cquotient object
 * @param {Array} anchorsArray array of objects representing anchors
 */
export function processRecommendationsTile($parentElement, einsteinUtils, anchorsArray) {
    var recommender = $parentElement.data('recommender');

    var params = {
        userId: einsteinUtils.getCQUserId(),
        cookieId: einsteinUtils.getCQCookieId(),
        ccver: '1.01'
    };

    if (anchorsArray) {
        params.anchors = anchorsArray;
    }

    /**
    * Processes a recommendation responses
    * @param {Object} einsteinResponse cquotient object
    */
    function recommendationsReceived(einsteinResponse) {
        fillDomElement(einsteinResponse, $parentElement, einsteinUtils);
        $parentElement.spinner().stop();
    }

    if (einsteinUtils.getRecs) {
        einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
    } else {
        einsteinUtils.widgets = einsteinUtils.widgets || []; // eslint-disable-line no-param-reassign
        einsteinUtils.widgets.push({
            recommenderName: recommender,
            parameters: params,
            callback: recommendationsReceived
        });
    }
}

/**
 * Rerieves data attributes from parent element and converts to gretel compatible recommenders array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createCategoryAnchor($parentElement) {
    return [{ id: $parentElement.data('categoryId') || $('.ds-container-fluid').data('category') }];
}

/**
 * Loads and processes all Einstein recommendation placeholders
 */
export function loadRecommendations() {
    var einsteinUtils = getEinsteinUtils();
    if (!einsteinUtils) return;

    // Cache DOM queries
    var $carousel = $('.experience-einstein-pvhEinsteinCarouselCategory, .experience-einstein-pvhEinsteinCarousel');

    $carousel.each(function () {
        var $el = $(this);
        var $container = $el.find('.experience-einReco-container');
        var $region = $el.closest('.region');
        var $columns = $container.find('.column');

        // Hide or adjust layout based on carousel content
        if ($el.children().length === 0) {
            $region.hide();
            return; // exit early (no need to process further)
        }

        $region
        .removeClass('d-column md-3 sm-3 productTileShow col-6 col-sm-4')
        .addClass('col-12');

        // Slides handling (cache selectors)
        var $slide1 = $container.find('.experience-region.experience-slide');
        var $slide = $slide1.find('.experience-component');
        var $videoMobile1 = $slide1.find('.mobile-only');
        var $videoDesktop1 = $slide1.find('.desktop-only');
        var $videoBanner = $slide1.find('.banner-component');
        var videoDataDesktop1 = $videoBanner.data('desktop');
        var videoDataMobile1 = $videoBanner.data('mobile');

        var $slide2 = $container.find('.experience-region.experience-slide2');
        var $slide2Cont = $slide2.find('.experience-component');
        var $videoMobile2 = $slide2.find('.mobile-only');
        var $videoDesktop2 = $slide2.find('.desktop-only');
        var $videoBanner2 = $slide2.find('.banner-component');
        var videoDataDesktop2 = $videoBanner2.data('desktop');
        var videoDataMobile2 = $videoBanner2.data('mobile');

        if ($slide1.children().length && $slide.children().length !== 0) {
            if ($videoMobile1.length && videoDataMobile1 && !videoDataDesktop1) {
                $slide1.addClass('column d-md-none sm-12 pr-40');
                $container.find('.column.sm-12').addClass('md-12');
            } else if ($videoDesktop1.length && videoDataDesktop1 && !videoDataMobile1) {
                $slide1.addClass('column d-sm-none d-md-block sm-12 md-6 pr-40');
                $container.find('.column.sm-12').addClass('md-6');
            } else {
                $slide1.addClass('column md-6 sm-12 pr-40');
                $container.find('.column.sm-12').addClass('md-6');
            }
        }

        if ($slide2.children().length && $slide2Cont.children().length !== 0) {
            if ($videoMobile2.length && videoDataMobile2 && !videoDataDesktop2) {
                $slide2.addClass('column d-md-none sm-12 pl-40');
                $container.find('.column.sm-12').addClass('md-12');
            } else if ($videoDesktop2.length && videoDataDesktop2 && !videoDataMobile2) {
                $slide2.addClass('column d-sm-none d-md-block sm-12 md-6 pl-40');
                $container.find('.column.sm-12').addClass('md-6');
            } else {
                $slide2.addClass('column md-6 sm-12 pl-40');
                $container.find('.column.sm-12').addClass('md-6');
            }

            $container.addClass('rightvideo');
        }

        // Adjust slides count only once
        if (!$columns.hasClass('md-6')) {
            noSlides = 6.5;
        }
    });

    // Process recommendation tiles
    $('.experience-einReco-wrapper').each(function () {
        var $els = $(this);
        $els.spinner().start();
        const $recentCarousel = $('.experience-einReco-wrapper').closest('experience-einstein-pvhEinsteinCarousel');
        if ($recentCarousel) {
            processRecommendationsTile(
                $els,
                einsteinUtils
            );
        } else {
            processRecommendationsTile(
                $els,
                einsteinUtils,
                createCategoryAnchor($els)
            );
        }
    });

    const $style = $('.experience-einReco-container').data('style');
    if ($('link[href="' + $style + '"]').length === 0) {
        $('<link>', {
            rel: 'stylesheet',
            type: 'text/css',
            href: $style
        }).appendTo('head');
    }
}

$(document).ready(function () {
    loadRecommendations();
});

export default {
    getEinsteinUtils,
    showControls,
    fillDomElement,
    processRecommendationsTile,
    createCategoryAnchor,
    loadRecommendations
};
